export default [
    { width: "120", height: "600" },
    { width: "180", height: "600" },
    { width: "300", height: "250" },
    { width: "300", height: "600" },
    { width: "720", height: "300" },
    { width: "970", height: "90" },
    { width: "970", height: "250" },
  ];
  